<template>
    <div>
        <DeviceSetupSplash
            v-if="showDeviceSetup"
            @continue="deviceSetupConfirmed = true"
        />
        <v-container v-else fluid>
            <v-row>
                <v-col 
                    cols=12 md=3 lg=2 
                    v-if="!isMobileSize() || selected == null"
                    class="pa-0"
                >
                    <FeatureList />
                </v-col>
                <v-col 
                    cols="6"
                    :class="isMobileSize() ? 'pa-0' : 'pb-16'"
                >
                    <FeatureEditor v-if="selected" :propertiesAreSelectable="true" class="pr-0"/>
                    <v-card 
                        v-else-if="!isMobileSize()"
                    >
                        <v-card-text>{{ $t('FeatureEditor.select') }}</v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="3">
                    <StoreEditorSettings />
                    
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import FeatureList from '@/components/FeatureList'
    import FeatureEditor from '@/components/FeatureEditor'
    import StoreEditorSettings from '@/components/StoreEditorSettings'
    import DeviceSetupSplash from '@/components/DeviceSetupSplash.vue'

    export default {
        components: {
            FeatureList,
            FeatureEditor,
            StoreEditorSettings,
            DeviceSetupSplash
        },
        data: () => ({
            deviceSetupConfirmed: false
        }),
        computed: {
            selected() {
                return this.$store.getters.selected
            },
            deviceSetupComplete() {
                return this.$store.getters.deviceSetupComplete
            },
            showDeviceSetup() {
                return !this.deviceSetupConfirmed
            }
        }
    }
</script>
